import CardComponent from 'core/card'
import { useState } from 'react'
import { OnGetHouseHoldCallback } from '../../NpvrComponent'
import SearchComponent from './components/Search'

type HouseHoldProps = {
  onGetHouseHold: OnGetHouseHoldCallback
  hhIdQuery: string
}

export default function HouseholdComponent({ onGetHouseHold, hhIdQuery = '' }: HouseHoldProps) {
  const [hhid, setHhid] = useState(hhIdQuery)

  return (
    <CardComponent>
      <SearchComponent hhid={hhid} setHhid={setHhid} onGetHouseHold={onGetHouseHold} />
    </CardComponent>
  )
}
